import { useRef } from "react";
import { useDocuments } from "@/zapi-frontend/shared/hooks/useDocuments";
import { useChapterStore } from "@/zapi-frontend/stores/chapter";

export function useFileUpload(projectId: string) {
  const { uploadingDocuments, setUploadingDocuments } = useDocuments(projectId);
  const { createDocument } = useDocuments(projectId);
  const { activeChapter } = useChapterStore();
  const chapterId = activeChapter?.id?.toString() || "";
  const attachmentFileInputRef = useRef<HTMLInputElement>(null);

  const handleFileUpload = async (files: FileList) => {
    if (files.length > 0) {
      const fileArray = Array.from(files);
      setUploadingDocuments(fileArray.map((f) => f.name));
      const promises = fileArray.map((file) => createDocument(file, chapterId));
      await Promise.all(promises);
      setUploadingDocuments([]);
    }
  };

  const openFileDialog = () => {
    attachmentFileInputRef.current?.click();
  };

  const handleFileInputChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      await handleFileUpload(e.target.files);
    }
  };

  return {
    uploadingDocuments,
    openFileDialog,
    attachmentFileInputRef,
    handleFileInputChange
  };
}
